var map = {
	"./amToEn.png": "2f26",
	"./arToEn.png": "3305",
	"./arToFr.png": "0acd",
	"./custom-gold/amToEn.png": "5c81",
	"./custom-gold/arToEn.png": "1856",
	"./custom-gold/arToFr.png": "acb8",
	"./custom-gold/enToAm.png": "f85c",
	"./custom-gold/enToAr.png": "e8f2",
	"./custom-gold/enToFr.png": "02e9",
	"./custom-gold/enToPt.png": "5554",
	"./custom-gold/enToSw.png": "90cd",
	"./custom-gold/enToTh.png": "ca43",
	"./custom-gold/frToAr.png": "1246",
	"./custom-gold/frToEn.png": "ca01",
	"./custom-gold/ptToEn.png": "8cb2",
	"./custom-gold/swToEn.png": "4e57",
	"./custom-gold/thToEn.png": "0549",
	"./enToAm.png": "9186",
	"./enToAr.png": "8003",
	"./enToFr.png": "c9fe",
	"./enToPt.png": "327a",
	"./enToSw.png": "ca9f",
	"./enToTh.png": "4558",
	"./frToAr.png": "771e",
	"./frToEn.png": "0528",
	"./ptToEn.png": "ba2e",
	"./self-blue/amToEn.png": "f4ff",
	"./self-blue/arToEn.png": "1df2",
	"./self-blue/arToFr.png": "9c3c",
	"./self-blue/enToAm.png": "4f56",
	"./self-blue/enToAr.png": "889d",
	"./self-blue/enToFr.png": "4227",
	"./self-blue/enToPt.png": "db68",
	"./self-blue/enToSw.png": "4565",
	"./self-blue/enToTh.png": "82dd",
	"./self-blue/frToAr.png": "8743",
	"./self-blue/frToEn.png": "1ead",
	"./self-blue/ptToEn.png": "1420",
	"./self-blue/swToEn.png": "bbf1",
	"./self-blue/thToEn.png": "9ef2",
	"./swToEn.png": "b2a5",
	"./thToEn.png": "0057"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46c5";